export function domReady(callback) {
    if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading") {
        callback();
    } else {
        document.addEventListener('DOMContentLoaded', callback);
    }
}

export function iterateNodes(selector, callback, ...args) {
    if (selector.constructor === Array) {
        selector = selector.join(', ');
    }

    let nodes = document.querySelectorAll(selector);
    nodes.forEach(node =>
        callback(node, ...args)
    );
}

export function addOrRemoveClass(node, addOrRemoveSetting) {
    if(node === null){
        return;
    }

    let removeClass = addOrRemoveSetting.removeClass || '';
    let addClass = addOrRemoveSetting.addClass || '';

    if (removeClass !== '') node.classList.remove(removeClass);
    if (addClass !== '') node.classList.add(addClass);
}

export function getNextSibling(node, selector) {
    let sibling = node.nextElementSibling;
    if (!selector) return sibling;

    // polyfill for IE
    if (!Element.prototype.matches) {
        Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    }

    while (sibling) {
        if (sibling.matches(selector)) return sibling;
        sibling = sibling.nextElementSibling;
    }
}

export function getPreviousSibling(node, selector) {
    let sibling = node.previousElementSibling;
    if (!selector) return sibling;

    // polyfill for IE
    if (!Element.prototype.matches) {
        Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    }

    while (sibling) {
        if (sibling.matches(selector)) return sibling;
        sibling = sibling.previousElementSibling;
    }
}

export function visibleInViewport(node) {
    let rect = node.getBoundingClientRect();

    return (
        rect.top >= 0 &&
        rect.left >= 0
    );
}

export function fullyInViewport(node) {
    let rect = node.getBoundingClientRect();

    return (
        visibleInViewport(node) &&
        rect.bottom <= window.innerHeight &&
        rect.right <= window.innerWidth
    );
}

